























































































































import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { casePriority } from '@/modules/Newcase/helpers/case'
import { Case } from '@/modules/Newcase/interfaces/case'
import { showErrors, showNotification } from '@/utils/snack'
import { dateTimeToDisplay, dateToDisplay, dateToNow } from '@/utils/dateTime'

import CaseDialog from '@/modules/Newcase/scripts/case-dialog'
import { updateCaseStep } from '@/modules/Newcase/gql/case.gql'
import { newQuote } from '@/modules/Quote/gql/quote.gql'
import { newPolicy } from '@/modules/Policy/gql/policy.gql'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'
import QuoteRequestTypeDialog from '@/modules/Quote/components/QuoteRequestTypeDialog.vue'
import QuoteRequestMailForm from '@/modules/Quote/components/QuoteRequestMailForm.vue'
import QuoteRequestTypeInForm from '@/modules/Quote/components/QuoteRequestTypeInForm.vue'

import dollarFilter from '@/utils/dollarFilter'
import AccountAssets from '@/modules/Newcase/components/AccountAssets.vue'
import AccountCertificates from '@/modules/Newcase/components/AccountCertificates.vue'
import AccountInfo from '@/modules/Newcase/components/AccountInfo.vue'
import CasePanel from '@/modules/Newcase/components/CasePanel.vue'
import QuoteDialog from '@/modules/Quote/scripts/quote-dialog'
import CaseQuoteDrawer from '@/modules/Newcase/components/CaseQuoteDrawer.vue'
import PolicyForm from '@/modules/Policy/components/PolicyForm.vue'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'
import { Quote } from '../../Quote/interfaces/quote'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import { states } from '@/utils/us_states'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'

@Component({
  components: {
    CaseFoldingCard,
    AccountAssets,
    AccountCertificates,
    AccountInfo,
    CasePanel,
    CaseQuoteDrawer,
    PolicyForm,
    QuoteRequestTypeDialog,
    QuoteRequestMailForm,
    QuoteRequestTypeInForm
  }
})
export default class CaseDetailQuoteAndProposal extends mixins(CaseDialog, QuoteDialog, PolicyDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  tableColumn = [
    { field: 'selected',
      title: 'Client Selected',
      slots: { default: 'selected_default' },
      width: 120,
      resizable: true
    },
    { field: 'name',
      title: 'Quote Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'carrier',
      title: 'GA / Carrier',
      slots: { default: 'carrier_default' },
      width: 250,
      resizable: true
    },
    { field: 'carrierProduct',
      title: 'Product',
      slots: { default: 'product_default' },
      width: 250,
      resizable: true
    },
    { field: 'totalAmount',
      title: 'Total Amount',
      slots: { default: 'total_amount_default' },
      width: 210,
      resizable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 100 }
  ]

  completeDialog = {
    show: false
  }

  previousDialog = {
    show: false
  }

  quickCreateDialog = {
    show: false
  }

  selectedIndex = -1

  dollarFilter = dollarFilter
  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay
  dateToNow = dateToNow
  casePriority = casePriority

  quoteDrawer = {
    show: false
  }

  typeDialog = {
    show: false
  }

  requestMailForm = {
    show: false
  }

  requestTypeInForm = {
    show: false,
    step: 0
  }

  get quotesList () {
    return this.caseInfo.quotes || []
  }

  get disableComplete () {
    return !this.targetQuote && this.policyInfoDialog.show
  }

  get producerForm () {
    if (!this.caseInfo.producerForm) {
      return null
    }
    return JSON.parse(this.caseInfo.producerForm)
  }

  get carrierProductInfo () {
    if (this.caseInfo.recordType.name === 'Personal Auto') {
      return {
        id: 11,
        name: 'Personal Private Auto'
      }
    }

    if (this.caseInfo.recordType.name === 'Homeowners') {
      return {
        id: 9,
        name: 'Home Owner'
      }
    }
    return null
  }

  @Watch('caseInfo')
  onCaseInfo (val: Case) {
    const quote = this.quotesList[this.selectedIndex]
    if (!quote) {
      this.targetQuote = null
      return
    }

    const { premiums } = quote

    if (!premiums || !premiums[0]) {
      this.targetQuote = null
      return
    }

    this.targetQuote = {
      ...quote,
      premiumInfo: premiums[0]
    } as Quote
  }

  @Watch('selectedIndex')
  onSelectedIndex (val: number, oldVal: number) {
    const quote = this.quotesList[val]
    if (!quote) {
      this.targetQuote = null
      return
    }

    const { premiums } = quote

    if (!premiums || !premiums[0]) {
      this.targetQuote = null
      return
    }

    this.targetQuote = {
      ...quote,
      premiumInfo: premiums[0]
    } as Quote
  }

  showGaCarrier (premium: any) {
    const { gaId, carrierName, gaName } = premium

    if (gaId) {
      return gaName
    } else {
      return carrierName
    }
  }

  showQuoteDetail (index: number) {
    this.targetQuote = this.quotesList[index]
    this.quoteDrawer.show = true
  }

  showRequestQuoteDialog (index: number) {
    this.targetQuote = this.quotesList[index]
    this.typeDialog.show = true
  }

  typeSelectedHandler (idx: number) {
    if (idx === 0) {
      this.requestTypeInForm.show = true
    } else {
      this.requestMailForm.show = true
    }
  }

  onDrawerClose () {
    this.quoteDrawer.show = false
  }

  toNextStep () {
    if (!this.targetQuote) {
      showNotification({
        msg: 'Please Check The Quote!',
        type: SnackType.Error
      })
      return
    }
    this.completeDialog.show = true
  }

  handleCreate () {
    this.targetQuote = null
    if (this.producerForm) {
      this.quickCreateDialog.show = true
      return
    }
    this.quoteDialog.show = true
  }

  async completeStepConfirm () {
    this.onSelectedIndex(this.selectedIndex, this.selectedIndex - 1)
    this.completeDialog.show = false
    this.policyInfoDialog.show = true
  }

  parseAdditionalInfo () {
    let additionalInfoInput = {}
    if (this.caseInfo.asset && this.caseInfo.asset.property) {
      const asset = this.caseInfo.asset
      additionalInfoInput = {
        address1: asset.property.address1 ? asset.property.address1 : '',
        address2: asset.property.address2 ? asset.property.address2 : '',
        city: asset.property.city ? asset.property.city : '',
        zipCode: asset.property.zipCode ? asset.property.zipCode : '',
        state: asset.property.state ? states.findIndex(st => asset.property.state === st) : -1
      }
    }
    return JSON.stringify(additionalInfoInput, (key, value) => {
      return value === 0 ? '0' : (value || '')
    })
  }

  async quickCreateQuoteConfirm () {
    let carrierProductId = null
    if (this.caseInfo.recordType.name === 'Personal Auto') {
      carrierProductId = 11
    }
    if (this.caseInfo.recordType.name === 'Homeowners') {
      carrierProductId = 9
    }
    const recordTypeId = this.caseInfo.recordType ? +this.caseInfo.recordType.id : null
    const accountId = this.caseInfo.account ? +this.caseInfo.account.id : null
    const sourceId = this.caseInfo.source ? +this.caseInfo.source.id : null
    const primaryContactId = this.caseInfo.primaryContact ? +this.caseInfo.primaryContact.id : null

    try {
      const res = await this.$apollo.mutate({
        mutation: newQuote,
        variables: {
          quoteInput: {
            name: this.caseInfo.inquiryName,
            additionalInfoStr: this.parseAdditionalInfo(),
            recordTypeId,
            accountId,
            primaryContactId,
            sourceId,
            carrierProductId,
            caseId: this.caseInfo ? Number(this.caseInfo.id) : null,
            type: this.caseInfo.type,
            status: 'QUOTING'
          }
        }
      })
      showNotification({
        msg: 'Create the new quote successfully',
        type: SnackType.Success
      })
      this.onSuccess()
      this.quickCreateDialog.show = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async quickCreatePolicyConfirm () {
    if (!this.targetQuote) return
    const { account, recordType, type, primaryContact, source, id: caseId } = this.caseInfo
    const { premiums, originalInceptionDate, id: quoteId, priorTerm, carrierProduct } = this.targetQuote
    const premiumInfo = premiums[0]
    const { effectiveDate, expirationDate, carrierId, gaId, agencyFee, brokerFee, taxesFee, stampingFee, billingType, inspectionFee, carrierPolicyFee, term, payerType, installmentPlan, commission, premium } = premiumInfo
    let status = 'NO_ACTIVE'
    const year = this.$moment.tz('America/New_York').year()
    const now = this.$moment.tz('America/New_York').unix()
    const policyName = `${account.name}-${recordType.name}-Policy-${type}${year}`
    if (effectiveDate) {
      if (now > effectiveDate) {
        status = 'EFFECTIVE'
      }
    }
    if (expirationDate) {
      if (now > expirationDate) {
        status = 'Expired'
      }
    }
    const nonRenew = false
    try {
      const res = await this.$apollo.mutate({
        mutation: newPolicy,
        variables: {
          policyInput: {
            policyName,
            policyNumber: '',
            status,
            type,
            effectiveDate: effectiveDate ? effectiveDate + '' : null,
            expirationDate: expirationDate ? expirationDate + '' : null,
            bindDate: effectiveDate ? effectiveDate + '' : null,
            originalInceptionDate: originalInceptionDate ? originalInceptionDate + '' : null,
            cancelDate: null,
            insuranceQuoteId: +quoteId || null,
            nonRenew,
            additionalInfoStr: this.parseAdditionalInfo(),
            recordTypeId: +recordType.id,
            accountId: +account.id,
            primaryContactId: primaryContact ? (+primaryContact.id || null) : null,
            sourceId: source ? (+source.id || null) : null,
            carrierProductId: carrierProduct ? +carrierProduct.id : null,
            priorTermId: priorTerm ? (+priorTerm.id || null) : null,
            carrierId: carrierId ? +carrierId : null,
            gaId: gaId ? +gaId : null,
            caseId: +caseId,
            premium: premium ? +premium : 0,
            agencyFee: agencyFee ? +agencyFee : 0,
            carrierPolicyFee: carrierPolicyFee ? +carrierPolicyFee : 0,
            inspectionFee: inspectionFee ? +inspectionFee : 0,
            stampingFee: stampingFee ? +stampingFee : 0,
            brokerFee: brokerFee ? +brokerFee : 0,
            taxesFee: taxesFee ? +taxesFee : 0,
            writingAgentIds: null,
            productCommissionOverride: commission ? +commission : 0,
            term: term ? Number(term) : null,
            billingType,
            installmentPlan: installmentPlan ? Number(installmentPlan) : null,
            payerType
          }
        }
      })
      showNotification({
        msg: 'Create the new policy successfully',
        type: SnackType.Success
      })
      this.updateStep()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  previousStepConfirm () {
    if (!this.caseInfo) {
      return
    }
    this.onSelectedIndex(this.selectedIndex - 1, this.selectedIndex)
    this.updatePreviousStep()
    this.previousDialog.show = false
  }

  async updateStep () {
    try {
      const result = await this.$apollo.mutate({
        mutation: updateCaseStep,
        variables: {
          caseId: Number(this.$route.params.id),
          step: this.caseInfo.step + 1
        }
      })
      if (!result.data) {
        showErrors(result.errors)
      }
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async updatePreviousStep () {
    try {
      const result = await this.$apollo.mutate({
        mutation: updateCaseStep,
        variables: {
          caseId: Number(this.$route.params.id),
          step: this.caseInfo.step - 1
        }
      })
      if (!result.data) {
        showErrors(result.errors)
      }
      this.onSuccess()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async deleteQuoteConfirm () {
    await this.deleteQuotePost()
    this.onSuccess()
  }

  createPremiumSuccess () {
    const quote = this.quotesList[this.selectedIndex]
    const { premiums } = quote
    this.targetQuote = {
      ...quote,
      premiumInfo: premiums[0]
    } as Quote
  }

  toPreviousStep () {
    this.previousDialog.show = true
  }

  selectQuote (index: number) {
    if (this.selectedIndex === index) {
      this.selectedIndex = -1
      return
    }
    this.selectedIndex = index
  }

  editQuoteHandler () {
    this.quoteDialog.title = 'Edit Quote'
    this.quoteDialog.show = true
  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }
}
